export default __webpack_public_path__ + "static/media/toyota2.81fd08e6.jpeg";